export const ReportTypes = {
  FacebookCommentReport: "FacebookCommentReport",
  FilteringDropdownReport: "FilteringDropdownReport",
  FilteringResultReport: "FilteringResultReport",
  ListicleReport: "ListicleReport",
  DragDropReport: "DragDropReport",
  LeadGenReport: "LeadGenReport",
  LeadGenPersonalityReport: "LeadGenPersonalityReport",
  ReceiptDataReport: "ReceiptDataReport",
  MemoryMatchReport: "MemoryMatchReport",
  PersonalityQuizReport: "PersonalityQuizReport",
  PollReport: "PollReport",
  ReceiptApprovalReport:"ReceiptApprovalReport",
  StateReport:"StateReport",
  ZipCodeReport:"ZipCodeReport",
  SurveyUserAnswerReport: "SurveyUserAnswerReport",
  ChecklistReport:"ChecklistReport",
  UGCSubmissionsReport: "UGCSubmissionsReport",
  UserReport:"UserReport",
  TriviaReport: "TriviaReport",
  PrizeEntriesReport: "PrizeEntriesReport",

};



// WEBPACK FOOTER //
// ./public/api/reports.js